/**
 * The shared virtual accounts-list fetch (TMMAPP-0004): one `GET /v1/virtual-accounts` per shell mount,
 * consumed by the Virtual accounts page (the cards), with one `reload()` and the `openCreate()`
 * action the page button and the allocate dialogs share (the sidebar's "+" left in TMMAPP-0150 U2).
 */
import { createContext, useContext } from 'react';
import type { VirtualAccountListItem } from '@/api/virtualAccounts';
import type { ApiError } from '@/api/errors';

export type VirtualAccountsListStatus = 'loading' | 'ready' | 'error';

export interface VirtualAccountsListValue {
  status: VirtualAccountsListStatus;
  items: VirtualAccountListItem[];
  error: ApiError | null;
  reload: () => Promise<void>;
  openCreate: () => void;
}

export const VirtualAccountsListContext = createContext<VirtualAccountsListValue | null>(null);

export function useVirtualAccountsList(): VirtualAccountsListValue {
  const value = useContext(VirtualAccountsListContext);
  if (!value)
    throw new Error('useVirtualAccountsList() must be used inside <VirtualAccountsListProvider>.');
  return value;
}

/** `null` outside the shell (genesis, a dialog rendered on its own in a test). */
export function useOptionalVirtualAccountsList(): VirtualAccountsListValue | null {
  return useContext(VirtualAccountsListContext);
}
